export const oidcConfiguration = {
  client_id: process.env.NEXT_PUBLIC_AUTH_IDENTITY_CLIENT_ID || '',
  redirect_uri: process.env.NEXT_PUBLIC_AUTH_REDIRECT_URL || '',
  silent_redirect_uri: process.env.NEXT_PUBLIC_AUTH_SILENT_REDIRECT_URL || '',
  scope: 'openid profile connect-call-centre/read connect-call-centre/write',
  authority: process.env.NEXT_PUBLIC_AUTH_AUTHORITY_URL || '',
  response_type: 'code',
  post_logout_redirect_uri: process.env.NEXT_PUBLIC_AUTH_LOGOFF_REDIRECT_URL || '',
  automaticSilentRenew: true,
  loadUserInfo: true,
}
